import { Component, inject, OnInit } from '@angular/core';
import { WizardType, RegistrationStepQuery, OrderItem, CHECKOUT_SUMMARY_SNAPSHOT } from '@fgb/core';

@Component({
  selector: 'fgbcl-registration-success-page',
  templateUrl: './registration-success-page.component.html',
  styleUrls: ['./registration-success-page.component.scss'],
})
export class RegistrationSuccessPageComponent implements OnInit {
  wizardType?: WizardType;
  wizardTypes = WizardType;
  url: string;
  checkoutItems: OrderItem[] = [];
  private checkoutSnapshot = inject(CHECKOUT_SUMMARY_SNAPSHOT);

  constructor(private registrationStepQuery: RegistrationStepQuery) {}

  ngOnInit() {
    this.wizardType = this.registrationStepQuery.getWizardType();

    let redirectToUrlAfterRegistration = sessionStorage.getItem('redirectToUrlAfterRegistration');
    if (redirectToUrlAfterRegistration) {
      this.url = redirectToUrlAfterRegistration;
    }

    this.checkoutItems = this.checkoutSnapshot?.items as OrderItem[];
  }
}
